import { useTranslation } from "react-i18next";
import { ChatObject } from "../../../../../../services/api/instances/botApi/types";
import { GenericSelect } from "../../../../../../shared/components/AppGenericSelect";
import { AppLabel } from "../../../../../../shared/components/AppLabel";
import styles from "./styles.module.css";

interface Props {
  chats: ChatObject[];
  chat: ChatObject | null;
  onSelectChat: (chat: ChatObject | null) => void;
}

export const DialogChatsSelection = ({ chats, chat, onSelectChat }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles["select-container"]}>
      <AppLabel className={styles.label}>
        {t("chatbot.channels_label")}
      </AppLabel>
      <GenericSelect<ChatObject>
        options={chats}
        value={chat}
        getLabel={(chat) => chat.chat_name}
        getValue={(chat) => chat.chat_id}
        onChange={onSelectChat}
        emptyOptionLabel={"Все чаты"}
      />
    </div>
  );
};
